import api from './axios';

export function getCompensationMeta(employeeUserId) {
  return api.get(`/users/${employeeUserId}/compensation`).then((r) => r.data);
}

export function revealCompensation(employeeUserId) {
  return api.post(`/users/${employeeUserId}/compensation/reveal`).then((r) => r.data);
}

export function putCompensation(employeeUserId, amount) {
  return api.put(`/users/${employeeUserId}/compensation`, { amount }).then((r) => r.data);
}
